export default __webpack_public_path__ + "static/media/gallery-wip-t-tracks_01.3d682d60.jpg";